// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"c68e6a76","141":"29447797","158":"37236e41","678":"9de27523","753":"c03f69f7","858":"3a1f011a"}[chunkId] + ".chunk.js";
};